import * as API from "./Api";

export const getProducts = (search, page, limit) =>
  API.get(`product?search=${search}&page=${page}&limit=${limit}`);
export const createProduct = (data) => API.post("product", data);
export const updateProduct = (id, data) => API.patch(`product/${id}`, data);
export const deleteProduct = (id) => API.remove(`product/${id}`);
